<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->

<template>
    <div class="min-h-screen bg-gray-50">
      <!-- 顶部导航 -->
      <div class="bg-white shadow-sm">
        <div class="max-w-8xl mx-auto px-2 h-16 flex items-center justify-between">
            <div class="relative"  v-if="isuse == 1">
              <button @click="toggleSupplierDropdown" class="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700 hover:bg-gray-50">
                <i class="fas fa-building"></i>
                <span class="whitespace-nowrap">{{ selectedSupplier.name || '选择供应商' }}</span>
                <i class="fas fa-chevron-down text-gray-400"></i>
              </button>
              <div v-if="showSupplierDropdown" class="absolute z-10 w-56 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg">
                <div class="py-2">
                  <div v-for="item in supply" :key="item.supply_id" @click="selectSupplier(item)" class="px-4 py-2 hover:bg-gray-50 cursor-pointer">
                     {{item.name}}
                  </div>
                </div>
              </div>
            </div>
          <div class="flex items-center space-x-4">
            <div class="flex items-center space-x-2">
              <input type="date" class="px-3 py-2 border rounded-lg text-sm" v-model="form.startDate">
              <span>至</span>
              <input type="date" class="px-3 py-2 border rounded-lg text-sm" v-model="form.endDate">
            </div>
            <button @click="search" class="!rounded-button flex items-center px-4 py-2 bg-blue-600 text-white hover:bg-blue-700">
              <i class="fas fa-sync-alt mr-2"></i>查询
            </button>
          </div>
        </div>
      </div>
  
      <!-- 核心指标 -->
      <div class="max-w-8xl mx-auto px-4 mt-6">
        <div class="grid grid-cols-4 gap-4">
          <div v-for="(card, index) in cards" :key="index" 
               class="bg-white rounded-lg p-6 shadow-sm">
            <div class="flex justify-between items-start">
              <div>
                <p class="text-gray-600 text-sm">{{ card.title }}</p>
                <p class="text-2xl font-semibold mt-2">{{ card.value }}</p>
              </div>
              <div :class="card.trend > 0 ? 'text-green-500' : 'text-red-500'" class="text-sm">
                {{ card.trend > 0 ? '+' : '' }}{{ card.trend }}%
                <i :class="card.trend > 0 ? 'fa-arrow-up' : 'fa-arrow-down'" class="fas"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- 图表区域 -->
      <div class="max-w-8xl mx-auto px-4 mt-6 grid grid-cols-2 gap-4">
        <!-- 订单趋势 -->
        <div class="bg-white rounded-lg p-6 shadow-sm">
          <h3 class="text-lg font-medium mb-4">订单趋势分析</h3>
          <div ref="orderTrendChart" style="height: 300px"></div>
        </div>
        <!-- 商品销售TOP10 -->
        <div class="bg-white rounded-lg p-6 shadow-sm">
          <h3 class="text-lg font-medium mb-4">热销商品 TOP 10</h3>
          <div ref="productRankChart" style="height: 300px"></div>
        </div>

      </div>
  
      <!-- 数据表格 -->
      <div class="max-w-8xl mx-auto px-4 mt-6 mb-8">
        <div class="bg-white rounded-lg shadow-sm">
          <div class="p-6 border-b">
            <div class="flex justify-between items-center">
              <h3 class="text-lg font-medium">订单明细</h3>
              <!-- <div class="flex items-center space-x-4">
                <div class="relative">
                  <input type="text" placeholder="搜索订单号/客户" 
                         class="pl-10 pr-4 py-2 border rounded-lg text-sm w-64">
                  <i class="fas fa-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                </div>
                <button class="!rounded-button px-4 py-2 border hover:bg-gray-50 whitespace-nowrap">
                  <i class="fas fa-download mr-2"></i>导出数据
                </button>
              </div> -->
            </div>
          </div>
          <div class="overflow-x-auto">
            <table class="w-full">
              <thead class="bg-gray-50">
                <tr>
                  <th v-for="header in tableHeaders" :key="header" 
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    {{ header }}
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="order in orders" :key="order.id">
                  <td class="px-6 py-4 whitespace-nowrap text-sm">{{ order.id }}</td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm">{{ order.customer }}</td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm">{{ order.amount }}</td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm">{{ order.date }}</td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm">
                    <span :class="order.status === '已完成' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'"
                          class="px-2 py-1 rounded-full text-xs">
                      {{ order.status }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="pagination">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background :current-page="curPage"
            :page-sizes="[20, 100,500, 1000]"
            layout="total,sizes, prev, pager, next, jumper"
            :total="totalDataNumber"></el-pagination>
        </div>
      </div>

    </div>
  </template>
  
  <script>
  import * as echarts from 'echarts';
  import StatisticsApi from '@/api/statistics.js';
  import Warehouse_managementApi from '@/api/warehouse_management.js';

  export default {
    data() {
      return {
        selectedSupplier: {'name':""},
        showSupplierDropdown: false,
        startDate: '',
        endDate: '',
        supply:[],
        form:{
            startDate: '',
            endDate: '',
        },
        isuse:0,
                    /*一页多少条*/
                    pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,

        cards: [
     
        ],
        tableHeaders: ['订单编号', '客户名称', '订单金额', '下单时间', '订单状态'],
        orders: [
        
        ]
      };
    },
    mounted() {
      var self = this;
    this.getInas({},function(res){
      self.isuse = res
    })
 this.getSupplys();
        this.search();
    },
    methods: {
      getSupplys(){
            let self = this;
    
    
            Warehouse_managementApi.getSupply({}, true)
                .then(data => {
              
                self.supply = data.data.supply
           
                })
                .catch(error => {
                });
        },
        search(){
          this.getOrderList();
            this.getCoreMetrics();
            this.getOrderTrend();
            this.getTopProducts();
            this.getOrderStatusDistribution();
          
        },
        /*获取数据*/
        getCoreMetrics() {
            let self = this;
            StatisticsApi.getCoreMetrics(self.form, true)
            .then(res => {
                    self.cards = res.data;
            })
            .catch(error => {});
      },
    
        /*获取数据*/
        getOrderTrend() {
            let self = this;
            const chart = echarts.init(this.$refs.orderTrendChart);
            StatisticsApi.getOrderTrend(self.form, true)
            .then(res => {
    
                chart.setOption({
                    animation: false,
                    tooltip: {
                    trigger: 'axis'
                    },
                    xAxis: {
                    type: 'category',
                    data: res.data.dates
                    },
                    yAxis: {
                    type: 'value'
                    },
                    series: [{
                    data: res.data.amount_data,
                    type: 'line',
                    smooth: true
                    },],
                    // series: [{
                    // data: res.data.order_data,
                    // type: 'line',
                    // smooth: true
                    // }]
                });
            })
            .catch(error => {});
      },
      getTopProducts() {
            let self = this;
            const chart = echarts.init(this.$refs.productRankChart);
            StatisticsApi.getTopProducts(self.form, true)
            .then(res => {
                chart.setOption({
                    animation: false,
                    tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                    },
                    xAxis: {
                    type: 'value'
                    },
                    yAxis: {
                    type: 'category',
                    data: res.data.products
                    },
                    series: [{
                    type: 'bar',
                    data:  res.data.sales
                    }]
                });    
    
            })
            .catch(error => {});
      },
      getOrderStatusDistribution() {
            let self = this;
            const chart = echarts.init(this.$refs.orderStatusChart);
            StatisticsApi.getOrderStatusDistribution(self.form, true)
            .then(res => {
                
                chart.setOption(res.data);
            })
            .catch(error => {});
      },
      getOrderList() {
            let self = this;
          
            let Params = self.form
            Params.page = self.curPage
            Params.list_rows = self.pageSize
            StatisticsApi.getOrderList(Params, true)
            .then(res => {
    
                self.orders = res.data.items;
                self.totalDataNumber = res.data.total
            })
            .catch(error => {});
      },


             /*选择第几页*/
     handleCurrentChange(val) {
            this.curPage = val
            this.getOrderList()
            },
            /*每页多少条*/
            handleSizeChange(val) {
            this.curPage = 1
            this.pageSize = val
            this.getOrderList()
        },      toggleSupplierDropdown() {
        this.showSupplierDropdown = !this.showSupplierDropdown;
      },
      selectSupplier(supplier) {
        this.selectedSupplier = supplier;
        this.showSupplierDropdown = false;
        this.form.supply_id = supplier.supply_id
      },
      handleDateChange() {
        if (this.startDate && this.endDate) {
          this.refreshData();
        }
      },

   
    }
  };
  </script>
  
  <style scoped>
  .fas {
    font-size: 14px;
  }
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  </style>
  
  


// WEBPACK FOOTER //
// src/views/statistics/driver/indexxx.vue